import { render } from "./VabeneLoyaltyCustomerDetail.vue?vue&type=template&id=57dbd7a6&scoped=true&ts=true"
import script from "./VabeneLoyaltyCustomerDetail.vue?vue&type=script&lang=ts"
export * from "./VabeneLoyaltyCustomerDetail.vue?vue&type=script&lang=ts"

import "./VabeneLoyaltyCustomerDetail.vue?vue&type=style&index=0&id=57dbd7a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57dbd7a6"]])

export default __exports__